export default "__VITE_ASSET__DJgOxb5A__"